import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import imageConfig from '../config/images';
import '../styles/CheckoutPage.css';

const PaymentSuccessPage: React.FC = () => {
  const [countdown, setCountdown] = useState<number>(15);
  const history = useHistory();
  const location = useLocation();
  
  // Get transaction ID from URL parameters
  const searchParams = new URLSearchParams(location.search);
  const transactionId = searchParams.get('order_id') || 'Unknown';
  
  // Handle countdown and redirect after successful purchase
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      
      return () => clearTimeout(timer);
    } else {
      // Redirect to home page
      history.replace('/box');
    }
  }, [countdown, history]);

  const backgroundStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${imageConfig.backgroundImage || imageConfig.defaultBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    margin: 0,
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1
  };

  return (
    <>
      <div className="checkout-page-background" style={backgroundStyle}></div>
      <div className="checkout-page">
        <div className="checkout-container">
          <h1>Payment Successful</h1>
          
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Thank You!</h2>
            <p>Your payment has been completed successfully. Your clipo will be sent to your email shortly.</p>
            <p>Transaction ID: {transactionId}</p>
            
            <div className="spam-warning">
              <p><strong>⚠️ Please check your spam folder if you don't see our email!</strong></p>
            </div>
            
            <p className="redirect-message">
              You will be redirected to the home page in {countdown} second{countdown !== 1 ? 's' : ''}...
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccessPage; 